module.exports = __webpack_public_path__ + "static/media/atef2.aece95b1.webp";